<script lang="ts" setup>
withDefaults(
    defineProps<{
        title?: string;
        description?: string;
    }>(),
    {
        title: '',
        description: '',
    },
);
</script>

<template>
    <div class="flex min-h-[52px] flex-col justify-between gap-3 p-4 sm:flex-row sm:items-center">
        <div class="min-w-0 flex-1 space-y-0.5">
            <slot name="title">
                <span class="block text-sm font-medium text-gray-900">{{ title }}</span>
            </slot>
            <slot name="description">
                <p v-if="description" class="text-xs leading-relaxed text-gray-500">
                    {{ description }}
                </p>
            </slot>
        </div>
        <div v-if="$slots.action" class="flex shrink-0 items-center gap-3">
            <slot name="action" />
        </div>
    </div>
</template>
